import React from 'react';
import Carousel2 from './Carousel2';
import CardsPrincipal from '../../CardsPrincipal';
import Separador from '../../Separador';
import CardsSection from '../../CardsSection';


const Home2 = () => {
  return (
    <div>
     
      <Carousel2 />
      <CardsPrincipal />
      <Separador />
      <CardsSection />
    </div>
  );
};

export default Home2;